import {
  collection,
  getDocs,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { firebaseDb } from '../firebase';

export const advertisementService = {
  /**
   * Obtenir les publicités actives (public)
   */
  getActiveAdvertisements: async (position = null) => {
    try {
      if (!firebaseDb) {
        return { success: false, error: 'Firestore non configuré', advertisements: [] };
      }
      let q = query(
        collection(firebaseDb, 'advertisements'),
        where('isActive', '==', true),
        orderBy('order', 'asc')
      );
      if (position) {
        q = query(
          collection(firebaseDb, 'advertisements'),
          where('isActive', '==', true),
          where('position', '==', position),
          orderBy('order', 'asc')
        );
      }
      const snap = await getDocs(q);
      const advertisements = snap.docs.map((d) => ({ id: d.id, _id: d.id, ...d.data() }));
      return {
        success: true,
        advertisements,
        count: advertisements.length,
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des publicités:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de la récupération des publicités',
        advertisements: [],
      };
    }
  },

  /**
   * Obtenir toutes les publicités (admin)
   */
  getAllAdvertisements: async (position = null, isActive = null) => {
    return advertisementService.getActiveAdvertisements(position);
  },

  /**
   * Créer une publicité (admin)
   */
  createAdvertisement: async (advertisementData) => {
    return { success: false, error: 'Création admin non disponible côté client en mode Firebase-only.' };
  },

  /**
   * Mettre à jour une publicité (admin)
   */
  updateAdvertisement: async (id, advertisementData) => {
    return { success: false, error: 'Mise à jour admin non disponible côté client en mode Firebase-only.' };
  },

  /**
   * Supprimer une publicité (admin)
   */
  deleteAdvertisement: async (id) => {
    return { success: false, error: 'Suppression admin non disponible côté client en mode Firebase-only.' };
  },

  /**
   * Enregistrer un clic
   */
  trackClick: async (id) => {
    return { success: true };
  },

  /**
   * Enregistrer une vue
   */
  trackView: async (id) => {
    return { success: true };
  },
};





